// extracted by mini-css-extract-plugin
export default {"root":"ButtonAddToCart_root__qPQEd","iconPlus":"ButtonAddToCart_iconPlus__OrFJH"};